import React, { useEffect, useState } from "react";

import axios from "axios";

import { toast } from "react-toastify";

import { Link, useNavigate } from "react-router-dom";

import { api } from "../Constants";

function MyProfile() {

 const [selectedImage, setSelectedImage] = useState(null);












 



  const [showPassword, setShowPassword] = useState({

    current: false,

    new: false,

    confirm: true,

  });



  const navigate = useNavigate();



  const userid = localStorage.getItem("userid");



  const [phone, setPhone] = useState("");



  const handleChange = (e) => {

    const numericValue = e.target.value.replace(/[^0-9]/g, "");

    setPhone(numericValue);

  };



  const togglePasswordVisibility = (field) => {

    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));

  };



  const [activeSection, setActiveSection] = useState(1);



  useEffect(() => {

    setActiveSection(1);

  }, []);



  const [passwordinputfields, setPasswordinputfields] = useState({

    currentpassword: "",

    newpassword: "",

    confirmpassword: "",

  });



  const [changepassworderrors, setChangepassworderrors] = useState({});



  const validatepassworderrors = (fields) => {

    let changepassworderrors = {};



    if (!fields.currentpassword || fields.currentpassword.trim() === "") {

      changepassworderrors.currentpassword = "Current Password is required";

    }



    if (!fields.newpassword || fields.newpassword.trim() === "") {

      changepassworderrors.newpassword = "New Password is required";

    } else if (fields.newpassword.length < 6) {

      changepassworderrors.newpassword =

        "Password must be alteast 6 Characters";

    }



    if (!fields.confirmpassword || fields.confirmpassword.trim() === "") {

      changepassworderrors.confirmpassword = "Confirm Password is required";

    }



    if (fields.newpassword !== fields.confirmpassword) {

      changepassworderrors.confirmpassword =

        "New Password & Confirm Password does not match";

    }



    return changepassworderrors;

  };



  const handlechangePassword = (e) => {

    e.preventDefault();



    const changepasswordvalidationerrors =

      validatepassworderrors(passwordinputfields);

    setChangepassworderrors(changepasswordvalidationerrors);



    if (Object.keys(changepasswordvalidationerrors).length === 0) {

      const changePassword = async () => {

        await axios

          .post(api + "change_password", {

            dealer_id: userid,

            old_password: passwordinputfields.currentpassword,

            password: passwordinputfields.newpassword,

            password_confirmation: passwordinputfields.confirmpassword,

          })

          .then((res) => {

            console.log(res);

            toast.success(res.data.message);

            setPasswordinputfields({

              currentpassword: "",

              newpassword: "",

              confirmpassword: "",

            });

          })

          .catch((error) => {

            console.log(error);

          });

      };



      changePassword();

    }

  };



  const handlepasswordchange = (e) => {

    setPasswordinputfields({

      ...passwordinputfields,

      [e.target.name]: e.target.value,

    });

  };



  const [inputformfields, setInputFormfields] = useState({

    name: "",

    email: "",

    phone: "",

  });



  const [fielderrors, setFielderrors] = useState({});



  const validation = (fields) => {

    let fielderrors = {};



    if (!fields.name || fields.name.trim() == "") {

      fielderrors.name = "Name is required";

    }



    if (!fields.email || fields.email.trim() == "") {

      fielderrors.email = "Email is required";

    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {

      fielderrors.email = "please enter a valid email address";

    }



    if (!fields.phone || fields.phone.trim() == "") {

      fielderrors.phone = "Phone Number is required";

    } else if (!/^\d{10,11}$/.test(fields.phone)) {

      fielderrors.phone = "Phone number must be 10 or 11 digits";

    }



    return fielderrors;

  };



  const getProfile = async () => {

    await axios

      .post(api + "get_profile", {

        dealer_id: userid,

      })

      .then((res) => {

        if (res.data.data.name) {

          setInputFormfields((prev) => ({

            ...prev,

            name: res.data.data.name,

          }));

        }



        if (res.data.data.mobile) {

          setInputFormfields((prev) => ({

            ...prev,

            phone: res.data.data.mobile,

          }));

        }



        if (res.data.data.email) {

          setInputFormfields((prev) => ({

            ...prev,

            email: res.data.data.email,

          }));

        }

      })

      .catch((error) => {

        console.log(error);

      });

  };



  const handleSubmit = (e) => {

    e.preventDefault();

    const vaidationerrors = validation(inputformfields);

    setFielderrors(vaidationerrors);



    if (Object.keys(vaidationerrors).length === 0) {

      const Profiledata = async () => {

        await axios

          .post(api + "update_profile", {

            dealer_id: userid,

            name: inputformfields.name,

            email: inputformfields.email,

            mobile: inputformfields.phone,

          })

          .then((res) => {

            toast.success("Profile Updated Successfully");

            getProfile();

          })

          .catch((errror) => {

            console.log(errror);

          });

      };

      Profiledata();

    }

  };



  const handlechange = (e) => {

    setInputFormfields({ ...inputformfields, [e.target.name]: e.target.value });

  };



  const handleMenuClick = (section) => {

    setActiveSection(section);

  };



  const handlePhonechange = (e) => {

    const { name, value } = e.target;

    if (/^\d*$/.test(value)) {

      setInputFormfields({

        ...inputformfields,

        [name]: value,

      });

    }

  };



  const handleNameChange = (e) => {

    const { name, value } = e.target;

    if (/^[a-zA-Z\s]*$/.test(value)) {

      setInputFormfields({

        ...inputformfields,

        [name]: value,

      });

    }

  };



  const [enquiryList, setEnquirylist] = useState([]);



  useEffect(() => {

    const fetchenquirylist = async () => {

      await axios

        .post(api + "enquiry_list", {

          dealer_id: userid,

        })

        .then((res) => {

          setEnquirylist(res.data.data);

        })

        .catch((error) => {

          console.log(error);

        });

    };

    if (userid) {

      fetchenquirylist();

    }

  }, [userid]);



  useEffect(() => {

    if (userid) {

      getProfile();

    }

  }, [userid]);



  const handlelogout = () => {

    localStorage.removeItem("username");

    localStorage.removeItem("email");

    localStorage.removeItem("phone");

    localStorage.removeItem("userid");

    navigate("/");

    window.location.reload();

  };



  const [enquirllistDetails, setenquirylistdetails] = useState([]);



  const hanfleViewlist = async (id) => {

    await axios

      .post(api + "enquiry_details", {

        enquiry_id: id,

      })

      .then((res) => {

        if (res.status === 200) {

          setenquirylistdetails(res.data.data);

          setActiveSection(4);

        }

      })

      .catch((err) => {

        console.log(err);

      });

  };



  return (

    <section className="py-5">

      <div className="container">

        <h2 className="mb-4">My Profile</h2>

        <div className="row">

          {/* Sidebar */}

          <div className="col-md-3 mb-4">

            <div className="card">

              <div

                className="card-header  text-white py-3"

                style={{ backgroundColor: "#dc3545" }}

              >

                <h5 className="mb-0 text-white">Profile Name</h5>

              </div>

              <div className="list-group list-group-flush ">

                <Link

                  className={`list-group-item list-group-item-action py-3 ${

                    activeSection === "profile" ? "active" : ""

                  }`}

                  onClick={() => handleMenuClick(1)}

                >

                  <i className="bi bi-person-circle me-2"></i> My Profile

                </Link>

                {/* <Link

                  className={`list-group-item list-group-item-action  py-3 ${

                    activeSection === "password" ? "active" : ""

                  }`}

                  onClick={() => handleMenuClick(2)}

                >

                  <i className="bi bi-key me-2"></i> Change Password

                </Link> */}

                <Link

                  className={`list-group-item list-group-item-action py-3 ${

                    activeSection === "enquiry" ? "active" : ""

                  }`}

                  onClick={() => handleMenuClick(3)}

                >

                  <i className="bi bi-question-circle me-2"></i> Enquiry List

                </Link>

                <Link

                  className="list-group-item list-group-item-action py-3"

                  onClick={() => handlelogout()}

                >

                  <i className="bi bi-box-arrow-right me-2"></i> Logout

                </Link>

              </div>

            </div>

          </div>



          {/* Main Content */}

          <div className="col-md-9">

            {/* Profile Section */}

            {activeSection === 1 && (

              <div className="card">

                <div

                  className="card-header  text-white py-3"

                  style={{ backgroundColor: "#dc3545" }}

                >

                  <h5 className="mb-0 text-white">Personal Details</h5>

                </div>

                <div className="card-body">

                  <form onSubmit={handleSubmit}>

                    <div className="row mb-3">

                      <div className="col-md-6">

                        <label htmlFor="Name" className="form-label">

                          Name

                        </label>

                        <input

                          type="text"

                          className="form-control"

                          name="name"

                          placeholder="Name"

                          onChange={handleNameChange}

                          value={inputformfields.name}

                        />

                        <p style={{ fontSize: "12px", color: "red" }}>

                          {fielderrors.name ? <>{fielderrors.name}</> : null}

                        </p>

                      </div>



                      <div className="col-md-6">

                        <label htmlFor="email" className="form-label">

                          Email

                        </label>

                        <input

                          type="email"

                          className="form-control"

                          name="email"

                          placeholder="Email"

                          onChange={handlechange}

                          value={inputformfields.email}

                        />

                        <p style={{ fontSize: "12px", color: "red" }}>

                          {fielderrors.email ? <>{fielderrors.email}</> : null}

                        </p>

                      </div>

                      <div className="col-md-6">

                        <label htmlFor="phone" className="form-label">

                          Phone

                        </label>

                        <input

                          type="tel"

                          className="form-control"

                          name="phone"

                          placeholder="Phone"

                          onChange={handlePhonechange}

                          maxLength={10}

                          value={inputformfields.phone}

                        />

                        <p style={{ fontSize: "12px", color: "red" }}>

                          {fielderrors.phone ? <>{fielderrors.phone}</> : null}

                        </p>

                      </div>

                    </div>



                    <div className="text-end">

                      <button

                        type="submit"

                        className="py-2 px-4 text-white"

                        style={{ backgroundColor: "#dc3545" }}

                      >

                        Save Changes

                      </button>

                    </div>

                  </form>

                </div>

              </div>

            )}



            {/* Change Password Section */}

            {activeSection === 2 && (

              <div className="card">

                <div

                  className="card-header  text-white py-3"

                  style={{ backgroundColor: "#dc3545" }}

                >

                  <h5 className="mb-0 text-white">Change Password</h5>

                </div>

                <div className="card-body">

                  <form onSubmit={handlechangePassword}>

                    <div className="mb-3">

                      <label htmlFor="currentPassword" className="form-label">

                        Current Password

                      </label>

                      <div className="position-relative">

                        <input

                          type={showPassword.current ? "text" : "password"}

                          className="form-control"

                          name="currentpassword"

                          placeholder="Current Password"

                          onChange={handlepasswordchange}

                          value={passwordinputfields.currentpassword}

                          style={{ paddingRight: "40px" }}

                        />

                        {changepassworderrors.currentpassword ? (

                          <p style={{ fontSize: "12px", color: "red" }}>

                            {changepassworderrors.currentpassword}

                          </p>

                        ) : null}

                        <span

                          className="position-absolute top-50 translate-middle-y"

                          style={{ cursor: "pointer", right: "20px" }}

                          onClick={() => togglePasswordVisibility("current")}

                        >

                          <i

                            className={`bi ${

                              showPassword.current ? " bi-eye" : "bi-eye-slash"

                            }`}

                          />

                        </span>

                      </div>

                    </div>



                    <div className="mb-3">

                      <label htmlFor="newPassword" className="form-label">

                        New Password

                      </label>

                      <div className="position-relative">

                        <input

                          type={showPassword.new ? "text" : "password"}

                          className="form-control pe-5"

                          name="newpassword"

                          placeholder="New Password"

                          onChange={handlepasswordchange}

                          value={passwordinputfields.newpassword}

                        />

                        {changepassworderrors.newpassword ? (

                          <p style={{ fontSize: "12px", color: "red" }}>

                            {changepassworderrors.newpassword}

                          </p>

                        ) : null}

                        <span

                          className="position-absolute top-50 translate-middle-y"

                          style={{ cursor: "pointer", right: "20px" }}

                          onClick={() => togglePasswordVisibility("new")}

                        >

                          <i

                            className={`bi ${

                              showPassword.new ? " bi-eye" : "bi-eye-slash"

                            }`}

                          />

                        </span>

                      </div>

                    </div>



                    <div className="mb-3">

                      <label htmlFor="confirmPassword" className="form-label">

                        Confirm New Password

                      </label>

                      <div className="position-relative">

                        <input

                          type="password"

                          className="form-control pe-5"

                          name="confirmpassword"

                          placeholder="Confirm New Password"

                          onChange={handlepasswordchange}

                          value={passwordinputfields.confirmpassword}

                        />

                        {changepassworderrors.confirmpassword ? (

                          <p style={{ fontSize: "12px", color: "red" }}>

                            {changepassworderrors.confirmpassword}

                          </p>

                        ) : null}

                      </div>

                    </div>



                    <div className="text-end">

                      <button

                        type="submit"

                        className="py-2 px-4  text-white"

                        style={{ backgroundColor: "#dc3545" }}

                      >

                        Update Password

                      </button>

                    </div>

                  </form>

                </div>

              </div>

            )}



            {/* Enquiry Details Section */}

            {activeSection === 3 && (

              <>

                {enquiryList.length > 0 ? (

                  <>

                    <div className="card enquiry_details">

                      <div

                        className="card-header  text-white py-3"

                        style={{ backgroundColor: "#dc3545" }}

                      >

                        <h5 className="mb-0 text-white">Enquiry List</h5>

                      </div>

                      <div className="card-body">

                        <div className="table-responsive">

                          <table className="table table-bordered table-hover">

                            <thead className="table-light">

                              <tr>

                                <th className="text-center">S.No</th>

                                <th className="text-center">Date</th>

                                <th className="text-center">City</th>



                                <th className="text-center">Message</th>

                                <th className="text-center">Action</th>

                              </tr>

                            </thead>



                            <tbody>

                              {enquiryList &&

                                enquiryList.map((item, index) => {

                                  return (

                                    <tr key={index}>

                                      <td className="text-center">

                                        {index + 1}

                                      </td>

                                      <td className="text-center">

                                        {item.created}

                                      </td>

                                      <td className="text-center">

                                        {item.city}

                                      </td>

                                      {/* <td>{item}</td> */}

                                      <td className="text-center">

                                        {item.message}

                                      </td>

                                      <td class="text-center">

                                        <button

                                          class="btn btn-cart"

                                          onClick={() => {

                                            hanfleViewlist(item.id);

                                          }}

                                          style={{

                                            border:

                                              "1px solid rgb(188, 24, 35)",

                                            textDecoration: "none",

                                          }}

                                        >

                                          View

                                        </button>

                                      </td>

                                    </tr>

                                  );

                                })}

                            </tbody>

                          </table>

                        </div>

                      </div>

                    </div>

                  </>

                ) : (

                  <p className="text-center"> Enquiry List is Empty</p>

                )}

              </>

            )}



            {/* Enquiry Details Section */}

            {activeSection === 4 && (

              <>

                {enquiryList.length > 0 ? (

                  <>

                    <div className="card enquiry_details">

                      <div

                        className="card-header  text-white py-3"

                        style={{ backgroundColor: "#dc3545" }}

                      >

                        <h5 className="mb-0 text-white">Enquiry Details</h5>

                      </div>

                      <div className="card-body">

                        <div className="table-responsive">

                          <table className="table table-bordered table-hover">

                            <thead className="table-light">

                              <tr>

                                <th className="text-center">S.No</th>

                                <th className="text-center">Image</th>

                                <th className="text-center">SKU</th>

                                <th className="text-center">Category</th>

                                <th className="text-center">Carat</th>

                                <th className="text-center">Quantity</th>

                                 <th className="text-center">Size</th>

                                 

                                <th className="text-center">Weight</th>

                               

                                

                                <th className="text-center">Remarks</th>

                              </tr>

                            </thead>

                                <>
      <tbody>
        {enquirllistDetails &&
          enquirllistDetails.map((item, index) => {
            return (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>


                     <td className="text-center">
                  <img
                    src={item.product_image_url}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    alt="product"
                    onClick={() => setSelectedImage(item.product_image_url)}
                  />
                </td>


            <td className="text-center">
  <Link
    to={`/product-details/${item.slug}`}
    className="text-primary text-decoration-underline"
  >
    {item.product_code}
  </Link>
</td>
                 <td className="text-center">{item.category}</td>
                <td className="text-center">{item.carat}</td>
                <td className="text-center">{item.qty}</td>
                <td className="text-center">{item.size}</td>
                
                <td className="text-center">{item.weight}</td>
              
                <td className="text-center">{item.remarks}</td>
              </tr>
            );
          })}
      </tbody>

      {/* Modal for Enlarged Image */}
      {selectedImage && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          onClick={() => setSelectedImage(null)} // Close modal on backdrop click
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()} // Prevent close on inner content click
          >
            <div className="modal-content " style={{ backgroundColor: "white" }}>
              <div className="modal-header">
                <h5 className="modal-title">Product Image</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedImage(null)}
                ></button>
              </div>
              <div className="modal-body text-center ">
                <img
                  src={selectedImage}
                  alt="Large Product"
                  className="img-fluid"
                  style={{ maxHeight: "70vh", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>

                          </table>

                        </div>

                      </div>

                    </div>

                  </>

                ) : (

                  <p className="text-center"> Enquiry Details List is Empty</p>

                )}

              </>

            )}

          </div>

        </div>

      </div>

    </section>

  );

}



export default MyProfile;

